import LegalLayout from "@/components/feature/LegalLayout";

const sectionTitle =
  "font-bold uppercase text-[#0A0A0A] text-[20px] md:text-[24px] mt-12 mb-4 tracking-tight";
const subTitle =
  "font-semibold text-[#0A0A0A] text-[16px] md:text-[18px] mt-8 mb-3";
const p = "text-foreground-700 text-sm md:text-base leading-relaxed mb-4";

export default function Datenschutz() {
  return (
    <LegalLayout
      title="Datenschutzerklärung"
      metaTitle="Datenschutzerklärung | Zweering Elektrotechnik Emmerich am Rhein"
      metaDescription="Datenschutzerklärung der Zweering Elektrotechnik GmbH in Emmerich am Rhein — Informationen zur Verarbeitung Ihrer Daten gemäß DSGVO."
      canonicalPath="/datenschutz"
    >
      <p className={p}>
        <strong>Inhaltsverzeichnis:</strong> Informationen zur Verarbeitung Ihrer Daten ·
        Welche Daten wir erheben · Cookies und integrierte Anwendungen · Technikhinweise
      </p>

      <h2 className={sectionTitle}>Allgemein</h2>
      <p className={p}>
        Diese Webseite ist ein Angebot der Firma Zweering Elektrotechnik GmbH, die den
        Datenschutz sehr ernst nimmt. Die Erhebung Ihrer Daten erfolgt im Rahmen der
        gesetzlichen Vorschriften. Nachfolgend zeigen wir Ihnen auf, welche Daten wir von
        Ihnen erheben, wie diese genutzt werden und welche Sicherheitsvorkehrungen
        getroffen wurden.
      </p>
      <p className={p}>
        Personenbezogene Daten sind alle Informationen, die sich auf eine identifizierte
        oder identifizierbare natürliche Person beziehen (z. B. Name, Anschrift,
        Telefonnummer, Geburtsdatum oder E-Mail-Adresse). Grundsätzlich können Sie unser
        Online-Angebot ohne Angabe personenbezogener Daten nutzen.
      </p>
      <p className={p}>
        Alle Mitarbeiterinnen und Mitarbeiter werden regelmäßig zum Datenschutz geschult
        und sind darauf verpflichtet.
      </p>

      <h2 className={sectionTitle}>I. Informationen zur Verarbeitung (Art. 13/14 DSGVO)</h2>

      <h3 className={subTitle}>a) Verantwortlich für die Datenverarbeitung</h3>
      <p className={p}>
        Zweering Elektrotechnik GmbH<br />
        An der Schleuse 10<br />
        46446 Emmerich am Rhein<br />
        E-Mail: datenschutz@zweering-elektro.de<br />
        Telefon: 0172 489 2149<br />
        Geschäftsführer: Bastian Zweering<br />
        HRB: 18815 · USt-IdNr.: DE330635296
      </p>

      <h3 className={subTitle}>b) Datenschutzbeauftragter</h3>
      <p className={p}>
        Julian Bach<br />
        s-Heerenberger Straße 251<br />
        46446 Emmerich am Rhein<br />
        Telefon: +49 162 699 2583<br />
        E-Mail: datenschutz@zweering-elektro.de
      </p>

      <h3 className={subTitle}>c) Verarbeitungszwecke</h3>
      <p className={p}>
        Eine Verarbeitung Ihrer personenbezogenen Daten erfolgt nur, wenn ein gesetzlicher
        Erlaubnistatbestand vorliegt: zur Vertragserfüllung, aufgrund einer gesetzlichen
        Vorschrift, mit Ihrer Einwilligung oder auf Grundlage berechtigter Interessen
        (Art. 6 DSGVO). Typische Zwecke sind Werbung und Marktforschung im zulässigen
        Umfang (§ 7 Abs. 3 UWG), Newsletter, die Bearbeitung von Kontaktanfragen sowie
        die Verwaltung eines Kundenkontos.
      </p>

      <h3 className={subTitle}>d) Speicherdauer</h3>
      <p className={p}>
        Wir bewahren Ihre Daten nur so lange auf, wie es zur Erfüllung des jeweiligen
        Zwecks erforderlich oder gesetzlich vorgeschrieben ist. Danach werden die Daten
        gesperrt oder gelöscht.
      </p>

      <h3 className={subTitle}>e) Weitergabe an Dritte</h3>
      <p className={p}>
        Eine Weitergabe erfolgt nur, soweit dies zur Vertragserfüllung erforderlich ist,
        ein berechtigtes Interesse besteht oder Sie eingewilligt haben (z. B. an
        Versandunternehmen oder Zahlungsdienstleister). Alle Mitarbeitenden sind zur
        Verschwiegenheit verpflichtet.
      </p>

      <h3 className={subTitle}>f/g) Dienstleister & Auftragsverarbeitung</h3>
      <p className={p}>
        Dienstleister erhalten nur die für ihre jeweilige Tätigkeit notwendigen Daten,
        in der Regel als Auftragsverarbeiter im Sinne von Art. 28 DSGVO.
        Kontakt: 0172 489 2149 / datenschutz@zweering-elektro.de.
      </p>

      <h3 className={subTitle}>h) Betroffenenrechte</h3>
      <p className={p}>
        Sie haben das Recht auf Auskunft, Berichtigung, Löschung, Einschränkung der
        Verarbeitung, Datenübertragbarkeit und Widerspruch. Zur Geltendmachung senden Sie
        bitte eine E-Mail an datenschutz@zweering-elektro.de.
      </p>

      <h3 className={subTitle}>i) Beschwerderecht</h3>
      <p className={p}>
        Landesbeauftragte für Datenschutz und Informationsfreiheit Nordrhein-Westfalen<br />
        Postfach 20 04 44 · 40102 Düsseldorf<br />
        Telefon: 0211/38424-0 · E-Mail: poststelle@ldi.nrw.de
      </p>

      <h3 className={subTitle}>j) Kontakt</h3>
      <p className={p}>
        Sie erreichen uns unter datenschutz@zweering-elektro.de. Bitte beachten Sie, dass
        bei einer Kontaktaufnahme per E-Mail die Vertraulichkeit der Informationen nicht
        umfassend gewährleistet werden kann. Vertrauliche Informationen senden Sie uns
        daher bitte auf dem Postweg zu.
      </p>

      <h2 className={sectionTitle}>II. Welche Daten wir erheben</h2>
      <h3 className={subTitle}>Log-Dateien</h3>
      <p className={p}>
        Sie können unsere Webseiten grundsätzlich ohne Angaben zu Ihrer Person besuchen.
        Bei jeder Nutzung werden automatisch bestimmte Informationen in Log-Dateien
        gespeichert und für 90 Tage zur Störungs- und Sicherheitsermittlung aufbewahrt:
        IP-Adresse, Referrer-URL, abgerufene Dateien, Datum und Uhrzeit, übertragene
        Datenmenge, Betriebssystem und Browser sowie HTTP-Status-Code.
      </p>

      <h2 className={sectionTitle}>III. Cookies und integrierte Anwendungen</h2>
      <p className={p}>
        Cookies sind kleine Textdateien, die beim Besuch unserer Seite auf Ihrem Endgerät
        gespeichert werden und eine Wiedererkennung ermöglichen (Session- bzw. temporäre
        oder permanente Cookies). In Cookies werden grundsätzlich keine personenbezogenen
        Daten gespeichert, sondern lediglich eine Online-Kennung. Sie können Cookies über
        Ihre Browser-Einstellungen deaktivieren oder löschen; dies kann die Funktionalität
        der Website einschränken.
      </p>
      <p className={p}>
        <strong>Unbedingt erforderliche Cookies:</strong> dienen der sicheren Bereitstellung
        des Angebots (z. B. Authentifizierung, temporäre Speicherung von Eingaben,
        Nutzerpräferenzen).
      </p>
      <p className={p}>
        <em>
          [Platzhalter — weitere auf dieser Seite tatsächlich eingebundene Dienste
          (z. B. Analytics, Tag Manager, reCAPTCHA, Maps, Pixel) werden ergänzt, sobald
          sie aktiv sind. Aktuell sind keine solchen Dienste auf dieser Seite im Einsatz.]
        </em>
      </p>

      <h2 className={sectionTitle}>IV. Technikhinweise & Consent-Tool</h2>
      <p className={p}>
        Hinweise zu Datenschutz-Einstellungen finden Sie in der jeweiligen Dokumentation
        Ihres Browsers (Microsoft Edge, Mozilla Firefox, Google Chrome, Apple Safari).
      </p>
      <p className={p}>
        Zur Verwaltung von Cookies und Einwilligungen setzen wir ein Consent-Management-Tool
        ein: <em>[Platzhalter — konkretes CMP wird ergänzt, sobald die Auswahl finalisiert
        ist.]</em> Rechtsgrundlagen: Art. 6 Abs. 1 lit. c und f DSGVO.
      </p>
    </LegalLayout>
  );
}
